import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "style-grid-container" }
const _hoisted_2 = { class: "grid-wrapper" }
const _hoisted_3 = { class: "pagination-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DuplicateStyle = _resolveComponent("DuplicateStyle")!
  const _component_GridLoading = _resolveComponent("GridLoading")!
  const _component_kendo_grid = _resolveComponent("kendo-grid")!
  const _component_BPagination = _resolveComponent("BPagination")!
  const _component_BModalOrchestrator = _resolveComponent("BModalOrchestrator")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DuplicateStyle, {
      showPopup: _ctx.showPopup,
      onVisibleDialog: _ctx.visibleDialog,
      duplicateStyleId: _ctx.duplicateStyleId,
      onDuplicateId: _ctx.getDuplicateId
    }, null, 8, ["showPopup", "onVisibleDialog", "duplicateStyleId", "onDuplicateId"]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_GridLoading)
    ], 512), [
      [_vShow, _ctx.styleloadingGrid || _ctx.loadingGrid]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createVNode(_component_kendo_grid, {
        ref: "detailsGrid",
        "data-source": _ctx.gridDataSource,
        columns: _ctx.columns,
        sortable: true,
        "column-menu": true,
        filterable: true,
        groupable: { messages: { empty: _ctx.groupTitle } },
        reorderable: true,
        selectable: true,
        "selected-field": _ctx.selectedField
      }, null, 8, ["data-source", "columns", "groupable", "selected-field"])
    ], 512), [
      [_vShow, !(_ctx.styleloadingGrid || _ctx.loadingGrid)]
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_BPagination, {
        modelValue: _ctx.currentPage,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
        "total-rows": _ctx.perPages,
        "per-page": 25,
        onPageClick: _ctx.onPaginationChange,
        size: "sm"
      }, null, 8, ["modelValue", "total-rows", "onPageClick"]),
      _createVNode(_component_BModalOrchestrator)
    ])
  ]))
}